import { ReactNode, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useUserInfoQuery } from "@/shared/api/queries"
import { useHandleRedirect } from "@/shared/lib/HandleRedirect"
import { useInitDimensions } from "@/shared/hooks/useInitDimensions"
import { usePreloadImages } from "@/shared/hooks/usePreloadImages"
import { useInitPostHog } from "@/shared/hooks/useInitPostHog"

interface UserProviderProps {
  children: ReactNode
}

export const UserProvider = ({ children }: UserProviderProps) => {
  const { i18n } = useTranslation()
  const { isLoading, user } = useUserInfoQuery()

  // Initialize app utilities
  useHandleRedirect()
  useInitDimensions()
  usePreloadImages()
  useInitPostHog()

  useEffect(() => {
    const initLanguage = async () => {
      const storedLang = localStorage.getItem("userLang")

      if (!isLoading && user) {
        const userLang = user.lang

        if (userLang) {
          if (userLang !== i18n.language) await i18n.changeLanguage(userLang)

          if (userLang !== storedLang)
            localStorage.setItem("userLang", userLang)

          return
        }
      }

      if (storedLang && storedLang !== i18n.language)
        await i18n.changeLanguage(storedLang)
    }

    initLanguage()
  }, [isLoading, user, i18n])

  return <>{children}</>
}
